const dirList = [];
require
  .context("./", true, /\/$/)
  .keys()
  .forEach(key => {
    const name = key.replace(/^\.\//, "").replace(/\/$/, "");
    name && dirList.push(name);
  });

export { dirList };
